import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Lightning = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path d="M9 2V7H13L7 14V9H3L9 2Z" />
    </svg>
  ),
)
Lightning.displayName = 'Lightning'

export default Lightning
